<section class="logout-wrapper">
  <div class="panel logout-card">
    <h1>You’ve been signed out</h1>
    <p>If you didn’t intend to sign out, you can sign back in.</p>
    <button type="button" class="act" (click)="loginAgain()">Sign in</button>
  </div>
</section>
